export default {
    namespaced: true,
    state: {
        alertParams: {
            display: false,
            type: 'success',
            content: ''
        },
        loadingBar: {
            display: false
        },
        cloader: {
            display: false,
            label: ''
        },
        snackbar: {
            display: false,
            label: '',
            duration: 0,
            mode: ''
        }
    },
    mutations: {
        triggerAlert(state, {type, msg}) {
            state.alertParams.type = type;
            state.alertParams.content = msg;
            state.alertParams.display = true;
        },
        setAlertState(state, value) {
            state.alertParams.display = value;
        },
        setLoadingBarState(state, value) {
            state.loadingBar.display = value;
        },
        cloader(state, value) {
            state.cloader = value
        },
        hideloader(state) {
            state.cloader = {
                display: false,
                label: '',
                mode: ''
            }
        },

        snackbar(state, value) {
            state.snackbar = value
        },
        resetSnackbar(state) {
            state.snackbar = {
                display: false,
                label: '',
                duration: 0,
                mode: ''
            }
        }

    },
    getters: {
        cloader(state) {
            return state.cloader
        },

        snackbar(state) {
            return state.snackbar
        }
    },
    actions: {}
};
